import { CompanyIndustry } from '../../../components/CompanyIndustry';
import { CompanyName } from '../../../components/CompanyName';
import { ExpandableText } from '../../../components/ExpandableText';
import type { Company } from '../../../domain/company';
import { useUserQuery } from '../../../features/user/useUserQuery';
import { AiOutreachButton } from '../AiOutreachButton/AiOutreachButton';
import { CompanyActionsContainer } from '../CompanyActionsContainer';
import { MeetingPrepButton } from '../MeetingPrepButton';
import { StyledSectionView } from '../styles';

import { StyledAgentsWrapper, StyledExpandableText } from './styles';

export const CompanyWidget = ({ company }: { company: Company }) => {
  const { data } = useUserQuery();

  return (
    <StyledSectionView withPadding data-automation="CompanyWidget">
      <CompanyName data-automation="CompanyName" company={company} />
      <CompanyActionsContainer company={company} />
      {company.industry ? <CompanyIndustry industry={company.industry} /> : null}
      <StyledExpandableText>
        <ExpandableText text={company.description} lineHeight={20} oneTime />
      </StyledExpandableText>
      <StyledAgentsWrapper>
        {data?.isCraftEmailAgentFeatureEnabled ? (
          <AiOutreachButton domain={company.domain} companyName={company.name} />
        ) : null}
        {data?.isMeetingAgentFeatureEnabled ? <MeetingPrepButton domain={company.domain} /> : null}
      </StyledAgentsWrapper>
    </StyledSectionView>
  );
};
